import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], saved: [] });

  const refresh = useCallback(async () => {
    if (!user) {
      setCart({ items: [], saved: [] });
      return;
    }
    try {
      const { data } = await api.get("/cart");
      setCart(data);
    } catch {
      /* ignore */
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const add = async (offerId, qty = 1) => {
    const { data } = await api.post("/cart/items", { offer_id: offerId, qty });
    setCart(data);
  };

  const updateQty = async (offerId, qty) => {
    const { data } = await api.put(`/cart/items/${offerId}`, { qty });
    setCart(data);
  };

  const toggleSave = async (offerId) => {
    const { data } = await api.post(`/cart/items/${offerId}/save-for-later`);
    setCart(data);
  };

  const count = cart.items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ cart, count, refresh, add, updateQty, toggleSave }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
